import { Exclude, Expose } from 'class-transformer';
import { FlowRuleCommonInterface } from '../interface/flow-rule-common.interface';

@Exclude()
export class FlowRuleCommonDto implements FlowRuleCommonInterface {
  @Expose()
  countRequired!: boolean;
}
